<template>
  <div class="onboarding_page">
    <h2>Innan ni gör utskick</h2>
    <p>
      Skapa en utskickmall under
      <a href="/ml-templates" target="_blank">Mallar</a> och gör sedan utskick via
      <a href="/ml-sendout" target="_blank">Utskick</a>.
    </p>
    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding_page11',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    next_page() {
      this.local_onboarding_data.sendout_shown = true;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
